import { Directive } from '@angular/core';
import { ITabGroup } from '../../_shared/models/tab/tab-group.model';

@Directive()
export abstract class TabGroupBaseDirective {
    config?: ITabGroup;
    currentIndex = 0;
}
